import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { darGraphqlApiSlice } from '../../apiSlice';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Char: { input: any; output: any };
  /** DateTime scalar as defined by https://scalars.graphql.org/andimarek/date-time.html but with 6 millisecond digits. */
  DafDateTime: { input: string; output: string };
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: number; output: number };
  UUID: { input: string; output: string };
};

/** The Register Import Status provides information about the status of the Register Data imports, as to what the most recent imported Register Data package is, and the corresponding most recent Event created as part of this data import package. */
export type Daf_RegisterImportStatus = {
  __typename?: 'DAF_RegisterImportStatus';
  /** Last Event ID of the imported register data package. */
  lastEventId: Scalars['Long']['output'];
  /** Last finished register import data package’s sequence number. */
  lastSequenceNumber: Scalars['Int']['output'];
  /** The date and time for when this current Register Import Status row was last updated. */
  lastUpdated: Scalars['DafDateTime']['output'];
};

/**
 * Grunddatamodel info:
 * name: Adresse
 * comment (da): <memo>#NOTES#en sammensat betegnelse, som udpeger og benævner en bestemt adgangsvej til et ubebygget areal, en bygning, en del af en bygning, et teknisk anlæg eller lignende. Reglerne for fastsættelse af adresser findes i adressebekendtgørelsen. BEK nr 271 af 13/04/2018.
 * definition (da): <memo>#NOTES#en struktureret betegnelse som angiver en særskilt adgang til et areal, en bygning eller en del af en bygning, efter reglerne i adressebekendtgørelsen
 * example (da): <memo>#NOTES#adressebetegnelse: Gimles Allé 14, 2300 København S   adressebetegnelse: Vestergade 4B, st. th, Strib, 5500 Middelfart
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
 * prefLabel (da): Adresse
 * URI: https://data.gov.dk/model/profile/dar/Adresse
 * EAID: EAID_6043F4D9_C4CA_44d0_BE88_027166A8B008
 */
export type Dar_Adresse = {
  __typename?: 'DAR_Adresse';
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/adressebetegnelse
   * prefLabel (da): adressebetegnelse
   * definition (da): en læsbar struktur, som identificerer adressen fuldstændigt
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P12
   */
  adressebetegnelse?: Maybe<Scalars['String']['output']>;
  bygning?: Maybe<Scalars['String']['output']>;
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/dørbetegnelse
   * prefLabel (da): dørbetegnelse
   * definition (da): betegnelse, som angiver den adgangsdør e.l. som adressen identificerer
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P22|||https://www.retsinformation.dk/eli/lta/2018/271#P23|||https://www.retsinformation.dk/eli/lta/2018/271#P12
   */
  doerbetegnelse?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Adressepunkt
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/dørpunkt
   * prefLabel (da): dørpunkt
   * definition (da): geografisk punkt, som udpeger beliggenheden af den adgangsdør e.l. som adressen identificerer
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  doerpunkt?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/etagebetegnelse
   * prefLabel (da): etagebetegnelse
   * definition (da): betegnelse, som angiver hvilken etage den del af bygningen som adressen identificerer, er beliggende på
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P12
   */
  etagebetegnelse?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forretningshændelse
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningshændelse
   * prefLabel (da): forretningshændelse
   * definition (da): den forretningshændelse, som afstedkom opdateringen af adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningshaendelse?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forretningsområde
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningsområde
   * prefLabel (da): forretningsområde
   * definition (da): det forretningsområde som har opdateret adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningsomraade?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forretningsproces
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den forretningsproces, som afstedkom opdateringen af adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningsproces?: Maybe<Scalars['String']['output']>;
  husnummer?: Maybe<Scalars['String']['output']>;
  id_lokalId?: Maybe<Scalars['String']['output']>;
  id_namespace?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/registreringFra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af den pågældende version af adresseelementet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringFra?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/registreringTil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor en ny registrering på adresseelementet er foretaget, og hvor denne version således ikke længere er den seneste
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/registreringsaktør
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen af den pågældende version af adresseelementet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringsaktoer?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Livscyklus
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/status
   * prefLabel (da): status
   * altLabel (da): status
   * definition (da): adresseelementets status i den pågældende version, dvs. elementets tilstand i den samlede livscyklus
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P39|||https://www.retsinformation.dk/eli/lta/2018/271#P45
   */
  status?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/virkningFra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra den pågældende version af adresseelementet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningFra?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/virkningTil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor virkningen af den pågældende version af adresseelementet ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: Virkningsaktør
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/virkningsaktør
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet virkningsegenskaberne for den pågældende version af adresseelementet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningsaktoer?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Dar_AdresseConnection = {
  __typename?: 'DAR_AdresseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Dar_AdresseEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Dar_Adresse>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Dar_AdresseEdge = {
  __typename?: 'DAR_AdresseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Dar_Adresse;
};

export type Dar_AdresseFilterInput = {
  adressebetegnelse?: InputMaybe<DafSearchableStringOperationFilterInput>;
  and?: InputMaybe<Array<Dar_AdresseFilterInput>>;
  bygning?: InputMaybe<DafStringOperationFilterInput>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  doerbetegnelse?: InputMaybe<DafStringOperationFilterInput>;
  doerpunkt?: InputMaybe<DafStringOperationFilterInput>;
  etagebetegnelse?: InputMaybe<DafStringOperationFilterInput>;
  husnummer?: InputMaybe<DafStringOperationFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringsaktoer?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningsaktoer?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: Adressepunkt
 * comment (da): <memo>#NOTES#datatypen beskriver position (stedfæstelse) samt geometri oprindelse for stedfastsættelsen. Anvendes af adgangspunkt, vejpunkt og dørpunkt
 * definition (da): <memo>#NOTES#klasse der samler de fælles egenskaber for et geografisk punkt, som er relevant for en adresse eller for et husnummer
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
 * prefLabel (da): Adressepunkt
 * source: https://danmarksadresser.dk/
 * URI: https://data.gov.dk/model/profile/dar/Adressepunkt
 * EAID: EAID_00A7AF01_C512_4a85_ADB5_98FB15541948
 */
export type Dar_Adressepunkt = {
  __typename?: 'DAR_Adressepunkt';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: Forretningshændelse
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningshændelse
   * prefLabel (da): forretningshændelse
   * definition (da): den forretningshændelse, som afstedkom opdateringen af adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningshaendelse?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forretningsområde
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningsområde
   * prefLabel (da): forretningsområde
   * definition (da): det forretningsområde som har opdateret adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningsomraade?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forretningsproces
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den forretningsproces, som afstedkom opdateringen af adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningsproces?: Maybe<Scalars['String']['output']>;
  id_lokalId?: Maybe<Scalars['String']['output']>;
  id_namespace?: Maybe<Scalars['String']['output']>;
  oprindelse_kilde?: Maybe<Scalars['String']['output']>;
  oprindelse_noejagtighedsklasse?: Maybe<Scalars['String']['output']>;
  oprindelse_registrering?: Maybe<Scalars['DafDateTime']['output']>;
  oprindelse_tekniskStandard?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: GM_Point
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/position
   * prefLabel (da): position
   * definition (da): geografisk punkt, som beskriver Adressepunktets beliggenhed
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   * CRS: EPSG:25832
   * Z-used: False
   */
  position?: Maybe<SpatialPointEpsg25832Type>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/registreringFra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af den pågældende version af adresseelementet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringFra?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/registreringTil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor en ny registrering på adresseelementet er foretaget, og hvor denne version således ikke længere er den seneste
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/registreringsaktør
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen af den pågældende version af adresseelementet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringsaktoer?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Livscyklus
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/status
   * prefLabel (da): status
   * altLabel (da): status
   * definition (da): adresseelementets status i den pågældende version, dvs. elementets tilstand i den samlede livscyklus
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P39|||https://www.retsinformation.dk/eli/lta/2018/271#P45
   */
  status?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/virkningFra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra den pågældende version af adresseelementet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningFra?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/virkningTil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor virkningen af den pågældende version af adresseelementet ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: Virkningsaktør
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/virkningsaktør
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet virkningsegenskaberne for den pågældende version af adresseelementet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningsaktoer?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Dar_AdressepunktConnection = {
  __typename?: 'DAR_AdressepunktConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Dar_AdressepunktEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Dar_Adressepunkt>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Dar_AdressepunktEdge = {
  __typename?: 'DAR_AdressepunktEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Dar_Adressepunkt;
};

export type Dar_AdressepunktFilterInput = {
  and?: InputMaybe<Array<Dar_AdressepunktFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  oprindelse_kilde?: InputMaybe<DafStringOperationFilterInput>;
  position?: InputMaybe<SpatialFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

export type Dar_Events = {
  __typename?: 'DAR_Events';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  entityname: Scalars['String']['output'];
  eventaction: Scalars['Char']['output'];
  eventid: Scalars['Long']['output'];
  fromfailedimport: Scalars['Boolean']['output'];
  object_datafordelerRowId: Scalars['UUID']['output'];
  object_datafordelerRowVersion: Scalars['Int']['output'];
  object_id?: Maybe<Scalars['String']['output']>;
  object_registreringfra?: Maybe<Scalars['DafDateTime']['output']>;
  object_registreringtil?: Maybe<Scalars['DafDateTime']['output']>;
  object_status?: Maybe<Scalars['String']['output']>;
  object_virkningfra?: Maybe<Scalars['DafDateTime']['output']>;
  object_virkningtil?: Maybe<Scalars['DafDateTime']['output']>;
};

/** A connection to a list of items. */
export type Dar_EventsConnection = {
  __typename?: 'DAR_EventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Dar_EventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Dar_Events>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Dar_EventsEdge = {
  __typename?: 'DAR_EventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Dar_Events;
};

export type Dar_EventsFilterInput = {
  and?: InputMaybe<Array<Dar_EventsFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafBoundedIntOperationFilterInput>;
  entityname?: InputMaybe<DafBoundedStringOperationFilterInput>;
  eventaction?: InputMaybe<DafBoundedCharOperationFilterInput>;
  eventid?: InputMaybe<DafBoundedLongOperationFilterInput>;
  object_id?: InputMaybe<DafBoundedStringOperationFilterInput>;
  object_status?: InputMaybe<DafBoundedStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: Husnummer
 * altLabel (da): Adgangsadresse
 * comment (da): <memo>#NOTES#når et adgangspunkt giver adgang til en eller flere adresser, indgår husnummeret i den samlede og fuldstændige adressebetegnelse for hver af disse. Reglerne for fastsættelse af Husnumre findes i adressebekendtgørelsen.
 * definition (da): <memo>#NOTES#betegnelse, som indgår i den samlede adressebetegnelse, idet den identificerer det adgangspunkt, som giver adgang til den eller de pågældende adresser
 * example (da): <memo>#NOTES#adgangsadressebetegnelse: Thorsgade 48A, 2200 København N  adgangspunkt: 723014.85 6178059.46  husnummerretning: 1 0   husnummertekst: 48A  vejpunkt: 723001.17 6178066.42
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P16|||https://www.retsinformation.dk/eli/lta/2018/271#P17|||https://www.retsinformation.dk/eli/lta/2018/271#P18|||https://www.retsinformation.dk/eli/lta/2018/271#P19
 * prefLabel (da): Husnummer
 * URI: https://data.gov.dk/model/profile/dar/Husnummer
 * EAID: EAID_D0A626FC_CCAE_4209_B2F6_AC919B74A528
 */
export type Dar_Husnummer = {
  __typename?: 'DAR_Husnummer';
  adgangTilBygning?: Maybe<Scalars['String']['output']>;
  adgangTilTekniskAnlaeg?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/adgangsadressebetegnelse
   * prefLabel (da): adgangsadressebetegnelse
   * definition (da): en læsbar struktur, som identificerer husnummeret fuldstændigt
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  adgangsadressebetegnelse?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Adressepunkt
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/adgangspunkt
   * prefLabel (da): adgangspunkt
   * definition (da): et geografisk punkt i terrænplan, som repræsenterer en adresses beliggenhed
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P13
   */
  adgangspunkt?: Maybe<Scalars['String']['output']>;
  afstemningsomraade?: Maybe<Scalars['String']['output']>;
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: Forretningshændelse
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningshændelse
   * prefLabel (da): forretningshændelse
   * definition (da): den forretningshændelse, som afstedkom opdateringen af adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningshaendelse?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forretningsområde
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningsområde
   * prefLabel (da): forretningsområde
   * definition (da): det forretningsområde som har opdateret adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningsomraade?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forretningsproces
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den forretningsproces, som afstedkom opdateringen af adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningsproces?: Maybe<Scalars['String']['output']>;
  geoDanmarkBygning?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: GM_Point
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/husnummerretning
   * prefLabel (da): husnummerretning
   * definition (da): geografisk punkt, der anvendes til at angive retningen for et husnummer (husnummertekst), i forhold til Adgangspunktet, når det skal vises på et kort
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   * CRS: EPSG:25832
   * Z-used: False
   */
  husnummerretning?: Maybe<SpatialPointEpsg25832Type>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/husnummertekst
   * prefLabel (da): husnummertekst
   * definition (da): husnummeret til adressen inklusive evt. bogstav
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P16
   */
  husnummertekst?: Maybe<Scalars['String']['output']>;
  id_lokalId?: Maybe<Scalars['String']['output']>;
  id_namespace?: Maybe<Scalars['String']['output']>;
  jordstykke?: Maybe<Scalars['String']['output']>;
  kommuneinddeling?: Maybe<Scalars['String']['output']>;
  menighedsraadsafstemningsomraade?: Maybe<Scalars['String']['output']>;
  navngivenVej?: Maybe<Scalars['String']['output']>;
  placeretPaaForeloebigtJordstykke?: Maybe<Scalars['String']['output']>;
  postnummer?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/registreringFra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af den pågældende version af adresseelementet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringFra?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/registreringTil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor en ny registrering på adresseelementet er foretaget, og hvor denne version således ikke længere er den seneste
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/registreringsaktør
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen af den pågældende version af adresseelementet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringsaktoer?: Maybe<Scalars['String']['output']>;
  sogneinddeling?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Livscyklus
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/status
   * prefLabel (da): status
   * altLabel (da): status
   * definition (da): adresseelementets status i den pågældende version, dvs. elementets tilstand i den samlede livscyklus
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P39|||https://www.retsinformation.dk/eli/lta/2018/271#P45
   */
  status?: Maybe<Scalars['String']['output']>;
  supplerendeBynavn?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/vejmidte
   * prefLabel (da): vejmidte
   * altLabel (da): kommunekode-vejkode
   * definition (da): kode for vejmidte for hvilken navngivenvejkommunedel som husnummeret er tilknyttet. Angivet som kommundekode-vejkode
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  vejmidte?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Adressepunkt
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/vejpunkt
   * prefLabel (da): vejpunkt
   * definition (da): et geografisk punkt, der repræsenterer det sted på den navngivne vej, som er adgangsgivende til et bestemt adgangspunkt
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P14
   */
  vejpunkt?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/virkningFra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra den pågældende version af adresseelementet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningFra?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/virkningTil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor virkningen af den pågældende version af adresseelementet ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: Virkningsaktør
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/virkningsaktør
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet virkningsegenskaberne for den pågældende version af adresseelementet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningsaktoer?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Dar_HusnummerConnection = {
  __typename?: 'DAR_HusnummerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Dar_HusnummerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Dar_Husnummer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Dar_HusnummerEdge = {
  __typename?: 'DAR_HusnummerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Dar_Husnummer;
};

export type Dar_HusnummerFilterInput = {
  adgangTilBygning?: InputMaybe<DafStringOperationFilterInput>;
  adgangTilTekniskAnlaeg?: InputMaybe<DafStringOperationFilterInput>;
  adgangsadressebetegnelse?: InputMaybe<DafSearchableStringOperationFilterInput>;
  adgangspunkt?: InputMaybe<DafStringOperationFilterInput>;
  afstemningsomraade?: InputMaybe<DafStringOperationFilterInput>;
  and?: InputMaybe<Array<Dar_HusnummerFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  geoDanmarkBygning?: InputMaybe<DafStringOperationFilterInput>;
  husnummerretning?: InputMaybe<SpatialFilterInput>;
  husnummertekst?: InputMaybe<DafStringOperationFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  jordstykke?: InputMaybe<DafStringOperationFilterInput>;
  kommuneinddeling?: InputMaybe<DafStringOperationFilterInput>;
  menighedsraadsafstemningsomraade?: InputMaybe<DafStringOperationFilterInput>;
  navngivenVej?: InputMaybe<DafStringOperationFilterInput>;
  placeretPaaForeloebigtJordstykke?: InputMaybe<DafStringOperationFilterInput>;
  postnummer?: InputMaybe<DafStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  sogneinddeling?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  supplerendeBynavn?: InputMaybe<DafStringOperationFilterInput>;
  vejmidte?: InputMaybe<DafStringOperationFilterInput>;
  vejpunkt?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: NavngivenVej
 * comment (da): <memo>#NOTES#en navngiven vej repræsenterer en del af færdselsnettet (dvs. vej, torv, sti e.l.) som er tildelt et særskilt vejnavn efter reglerne i adressebekendtgørelsen, uanset om vejen ligger inden for en kommune eller krydser en eller flere kommunegrænser.
 * definition (da): <memo>#NOTES#et samlet færdselsareal, uafhængigt af kommunegrænser, for hvilket der er fastsat ét vejnavn
 * example (da): <memo>#NOTES#administreresAfKommune: 0230 beskrivelse: [?] udtaltVejnavn: Gammel Dronninggårds Alle vejadresseringsnavn: Gl. Dronninggårds A. vejnavn: Gl. Dronninggårds Alle vejnavnebeliggenhed: [koordinatorsæt med flere punkter] , Geometrioprindelse
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P3|||https://www.retsinformation.dk/eli/lta/2018/271#P4|||https://www.retsinformation.dk/eli/lta/2018/271#P5|||https://www.retsinformation.dk/eli/lta/2018/271#P6|||https://www.retsinformation.dk/eli/lta/2018
 * prefLabel (da): Navngiven vej
 * URI: https://data.gov.dk/model/profile/dar/NavngivenVej
 * EAID: EAID_0CB629B5_8D1F_486c_A319_717EDF879B82
 */
export type Dar_NavngivenVej = {
  __typename?: 'DAR_NavngivenVej';
  /**
   * Grunddatamodel info:
   * type: Kommunekode
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/administreresAfKommune
   * prefLabel (da): administreres af kommune
   * altLabel (da): Registreringsansvarlig
   * definition (da): angivelse af den kommune som registreringsansvarlig for vejnavn og geometri for den navngivne vej
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P38
   */
  administreresAfKommune?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/beskrivelse
   * prefLabel (da): beskrivelse
   * definition (da): kort beskrivelse af vejnavnets oprindelse eller betydning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  beskrivelse?: Maybe<Scalars['String']['output']>;
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: Forretningshændelse
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningshændelse
   * prefLabel (da): forretningshændelse
   * definition (da): den forretningshændelse, som afstedkom opdateringen af adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningshaendelse?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forretningsområde
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningsområde
   * prefLabel (da): forretningsområde
   * definition (da): det forretningsområde som har opdateret adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningsomraade?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forretningsproces
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den forretningsproces, som afstedkom opdateringen af adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningsproces?: Maybe<Scalars['String']['output']>;
  id_lokalId?: Maybe<Scalars['String']['output']>;
  id_namespace?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/registreringFra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af den pågældende version af adresseelementet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringFra?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/registreringTil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor en ny registrering på adresseelementet er foretaget, og hvor denne version således ikke længere er den seneste
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/registreringsaktør
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen af den pågældende version af adresseelementet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringsaktoer?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Livscyklus
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/status
   * prefLabel (da): status
   * altLabel (da): status
   * definition (da): adresseelementets status i den pågældende version, dvs. elementets tilstand i den samlede livscyklus
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P39|||https://www.retsinformation.dk/eli/lta/2018/271#P45
   */
  status?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/udtaltVejnavn
   * prefLabel (da): udtalt vejnavn
   * definition (da): vejnavnet skrevet fuldt ud, således som det udtales
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P38
   */
  udtaltVejnavn?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/vejadresseringsnavn
   * prefLabel (da): vejadresseringsnavn
   * definition (da): forkortet udgave af vejnavnet på højst 20 tegn
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P5
   */
  vejadresseringsnavn?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/vejnavn
   * prefLabel (da): vejnavn
   * definition (da): det fulde vejnavn defineret som: Et egennavn, som udpeger og benævner en del af vej- eller stinettet eller lignende færdselsarealer og områder
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P5
   */
  vejnavn?: Maybe<Scalars['String']['output']>;
  vejnavnebeliggenhed_oprindelse_kilde?: Maybe<Scalars['String']['output']>;
  vejnavnebeliggenhed_oprindelse_noejagtighedsklasse?: Maybe<
    Scalars['String']['output']
  >;
  vejnavnebeliggenhed_oprindelse_registrering?: Maybe<
    Scalars['DafDateTime']['output']
  >;
  vejnavnebeliggenhed_oprindelse_tekniskStandard?: Maybe<
    Scalars['String']['output']
  >;
  vejnavnebeliggenhed_vejnavnelinje?: Maybe<SpatialMultiLineStringEpsg25832Type>;
  vejnavnebeliggenhed_vejnavneomraade?: Maybe<SpatialPolygonEpsg25832Type>;
  vejnavnebeliggenhed_vejtilslutningspunkter?: Maybe<SpatialMultiPointEpsg25832Type>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/virkningFra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra den pågældende version af adresseelementet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningFra?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/virkningTil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor virkningen af den pågældende version af adresseelementet ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: Virkningsaktør
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/virkningsaktør
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet virkningsegenskaberne for den pågældende version af adresseelementet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningsaktoer?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Dar_NavngivenVejConnection = {
  __typename?: 'DAR_NavngivenVejConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Dar_NavngivenVejEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Dar_NavngivenVej>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Dar_NavngivenVejEdge = {
  __typename?: 'DAR_NavngivenVejEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Dar_NavngivenVej;
};

export type Dar_NavngivenVejFilterInput = {
  and?: InputMaybe<Array<Dar_NavngivenVejFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  vejnavn?: InputMaybe<DafSearchableStringOperationFilterInput>;
  vejnavnebeliggenhed_vejnavnelinje?: InputMaybe<SpatialFilterInput>;
  vejnavnebeliggenhed_vejnavneomraade?: InputMaybe<SpatialFilterInput>;
  vejnavnebeliggenhed_vejtilslutningspunkter?: InputMaybe<SpatialFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: NavngivenVejKommunedel
 * comment (da): <memo>#NOTES#navngiven Vej Kommunedel angiver at en navngiven vej berører en bestemt kommune. Objektet indeholder bl.a.  Kommune- og Vejkoder som det er nødvendigt at bibeholde for at identificere et vejnavn , af hensyn til den eksisterende systemmasse
 * definition (da): <memo>#NOTES#den del af den navngivne vej der berører en bestemt kommune
 * example (da): <memo>#NOTES#kommune: 0101 vejkode: 1972
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P9
 * prefLabel (da): Navngiven vej kommunedel
 * URI: https://data.gov.dk/model/profile/dar/NavngivenVejKommunedel
 * EAID: EAID_34D070E5_DD89_4984_8054_16BA70936EA0
 */
export type Dar_NavngivenVejKommunedel = {
  __typename?: 'DAR_NavngivenVejKommunedel';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: Forretningshændelse
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningshændelse
   * prefLabel (da): forretningshændelse
   * definition (da): den forretningshændelse, som afstedkom opdateringen af adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningshaendelse?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forretningsområde
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningsområde
   * prefLabel (da): forretningsområde
   * definition (da): det forretningsområde som har opdateret adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningsomraade?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forretningsproces
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den forretningsproces, som afstedkom opdateringen af adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningsproces?: Maybe<Scalars['String']['output']>;
  id_lokalId?: Maybe<Scalars['String']['output']>;
  id_namespace?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Kommunekode
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/kommune
   * prefLabel (da): kommune
   * definition (da): kommunekoden for den kommune, som den pågældende del af den navngivne vej hører til
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  kommune?: Maybe<Scalars['String']['output']>;
  navngivenVej?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/registreringFra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af den pågældende version af adresseelementet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringFra?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/registreringTil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor en ny registrering på adresseelementet er foretaget, og hvor denne version således ikke længere er den seneste
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/registreringsaktør
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen af den pågældende version af adresseelementet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringsaktoer?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Livscyklus
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/status
   * prefLabel (da): status
   * altLabel (da): status
   * definition (da): adresseelementets status i den pågældende version, dvs. elementets tilstand i den samlede livscyklus
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P39|||https://www.retsinformation.dk/eli/lta/2018/271#P45
   */
  status?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/vejkode
   * prefLabel (da): vejkode
   * definition (da): entydig identifikation af den del af en Navngiven Vej, der berører en enkelt kommune
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P9
   */
  vejkode?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/virkningFra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra den pågældende version af adresseelementet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningFra?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/virkningTil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor virkningen af den pågældende version af adresseelementet ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: Virkningsaktør
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/virkningsaktør
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet virkningsegenskaberne for den pågældende version af adresseelementet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningsaktoer?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Dar_NavngivenVejKommunedelConnection = {
  __typename?: 'DAR_NavngivenVejKommunedelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Dar_NavngivenVejKommunedelEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Dar_NavngivenVejKommunedel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Dar_NavngivenVejKommunedelEdge = {
  __typename?: 'DAR_NavngivenVejKommunedelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Dar_NavngivenVejKommunedel;
};

export type Dar_NavngivenVejKommunedelFilterInput = {
  and?: InputMaybe<Array<Dar_NavngivenVejKommunedelFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  kommune?: InputMaybe<DafStringOperationFilterInput>;
  navngivenVej?: InputMaybe<DafStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  vejkode?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

export type Dar_NavngivenVejPostnummer = {
  __typename?: 'DAR_NavngivenVejPostnummer';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  forretningshaendelse?: Maybe<Scalars['String']['output']>;
  forretningsomraade?: Maybe<Scalars['String']['output']>;
  forretningsproces?: Maybe<Scalars['String']['output']>;
  id_lokalId?: Maybe<Scalars['String']['output']>;
  id_namespace?: Maybe<Scalars['String']['output']>;
  navngivenVej?: Maybe<Scalars['String']['output']>;
  postnummer?: Maybe<Scalars['String']['output']>;
  registreringFra?: Maybe<Scalars['DafDateTime']['output']>;
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  registreringsaktoer?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  virkningFra?: Maybe<Scalars['DafDateTime']['output']>;
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  virkningsaktoer?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Dar_NavngivenVejPostnummerConnection = {
  __typename?: 'DAR_NavngivenVejPostnummerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Dar_NavngivenVejPostnummerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Dar_NavngivenVejPostnummer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Dar_NavngivenVejPostnummerEdge = {
  __typename?: 'DAR_NavngivenVejPostnummerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Dar_NavngivenVejPostnummer;
};

export type Dar_NavngivenVejPostnummerFilterInput = {
  and?: InputMaybe<Array<Dar_NavngivenVejPostnummerFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  navngivenVej?: InputMaybe<DafStringOperationFilterInput>;
  postnummer?: InputMaybe<DafStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

export type Dar_NavngivenVejSupplerendeBynavn = {
  __typename?: 'DAR_NavngivenVejSupplerendeBynavn';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  forretningshaendelse?: Maybe<Scalars['String']['output']>;
  forretningsomraade?: Maybe<Scalars['String']['output']>;
  forretningsproces?: Maybe<Scalars['String']['output']>;
  id_lokalId?: Maybe<Scalars['String']['output']>;
  id_namespace?: Maybe<Scalars['String']['output']>;
  navngivenVej?: Maybe<Scalars['String']['output']>;
  registreringFra?: Maybe<Scalars['DafDateTime']['output']>;
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  registreringsaktoer?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplerendeBynavn?: Maybe<Scalars['String']['output']>;
  virkningFra?: Maybe<Scalars['DafDateTime']['output']>;
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  virkningsaktoer?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Dar_NavngivenVejSupplerendeBynavnConnection = {
  __typename?: 'DAR_NavngivenVejSupplerendeBynavnConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Dar_NavngivenVejSupplerendeBynavnEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Dar_NavngivenVejSupplerendeBynavn>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Dar_NavngivenVejSupplerendeBynavnEdge = {
  __typename?: 'DAR_NavngivenVejSupplerendeBynavnEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Dar_NavngivenVejSupplerendeBynavn;
};

export type Dar_NavngivenVejSupplerendeBynavnFilterInput = {
  and?: InputMaybe<Array<Dar_NavngivenVejSupplerendeBynavnFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  navngivenVej?: InputMaybe<DafStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  supplerendeBynavn?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: Postnummer
 * comment (da): <memo>#NOTES#efter postloven er det den befordringspligtige postvirksomhed, der administrerer postnummersystemet. Postnumrenes geografiske afgrænsning registreres i DAGI
 * definition (da): <memo>#NOTES#postnummer med tilhørende navn som indgår i det landsdækkende postnummersystem
 * example (da): <memo>#NOTES#Postnr: 8000 navn: Aarhus C
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * legalSource: https://www.retsinformation.dk/eli/lta/2017/136#P5
 * prefLabel (da): Postnummer
 * URI: https://data.gov.dk/model/profile/dar/Postnummer
 * EAID: EAID_449B3570_F0F7_494e_9756_D49E60644CD0
 */
export type Dar_Postnummer = {
  __typename?: 'DAR_Postnummer';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: Forretningshændelse
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningshændelse
   * prefLabel (da): forretningshændelse
   * definition (da): den forretningshændelse, som afstedkom opdateringen af adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningshaendelse?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forretningsområde
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningsområde
   * prefLabel (da): forretningsområde
   * definition (da): det forretningsområde som har opdateret adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningsomraade?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forretningsproces
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den forretningsproces, som afstedkom opdateringen af adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningsproces?: Maybe<Scalars['String']['output']>;
  id_lokalId?: Maybe<Scalars['String']['output']>;
  id_namespace?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/postnummernavn
   * prefLabel (da): navn
   * altLabel (da): Postdistrikt
   * definition (da): navn på by, bydel e.l., som postnummeret omfatter
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  navn?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/postnr
   * prefLabel (da): postnr
   * definition (da): kode på fire cifre som identificerer postnummeret
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  postnr?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Postnummerinddeling
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/postnummerinddeling
   * prefLabel (da): postnummerinddeling
   * definition (da): reference til DAGI's objekt for dette postnummer
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  postnummerinddeling?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/registreringFra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af den pågældende version af adresseelementet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringFra?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/registreringTil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor en ny registrering på adresseelementet er foretaget, og hvor denne version således ikke længere er den seneste
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/registreringsaktør
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen af den pågældende version af adresseelementet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringsaktoer?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Livscyklus
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/status
   * prefLabel (da): status
   * altLabel (da): status
   * definition (da): adresseelementets status i den pågældende version, dvs. elementets tilstand i den samlede livscyklus
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P39|||https://www.retsinformation.dk/eli/lta/2018/271#P45
   */
  status?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/virkningFra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra den pågældende version af adresseelementet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningFra?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/virkningTil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor virkningen af den pågældende version af adresseelementet ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: Virkningsaktør
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/virkningsaktør
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet virkningsegenskaberne for den pågældende version af adresseelementet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningsaktoer?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Dar_PostnummerConnection = {
  __typename?: 'DAR_PostnummerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Dar_PostnummerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Dar_Postnummer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Dar_PostnummerEdge = {
  __typename?: 'DAR_PostnummerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Dar_Postnummer;
};

export type Dar_PostnummerFilterInput = {
  and?: InputMaybe<Array<Dar_PostnummerFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  navn?: InputMaybe<DafSearchableStringOperationFilterInput>;
  postnr?: InputMaybe<DafSearchableStringOperationFilterInput>;
  postnummerinddeling?: InputMaybe<DafStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringsaktoer?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: SupplerendeBynavn
 * comment (da): <memo>#NOTES#det er adressemyndigheden der fastsætter det supplerende bynavn og dettes afgrænsning efter reglerne i adressebekendtgørelsen. Et supplerende bynavn er et bynavn eller et andet lokalt stednavn som er en underinddeling af et postnummer. Supplerende bynavn er en optionel tilføjelse til adressebetegnelsen. Den geografiske afgrænsning registreres i DAGI
 * definition (da): <memo>#NOTES#navn på et supplerende bynavn som præciser en adresses eller et vejnavns beliggenhed inden for postnummeret
 * example (da): <memo>#NOTES#Navn: ”Kragerup” , supplerendeBynavn: "655869"
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P11
 * prefLabel (da): Supplerende bynavn
 * URI: https://data.gov.dk/model/profile/dar/SupplerendeBynavn
 * EAID: EAID_9D39B21D_E73C_4f1b_9C6C_B75412DAAD77
 */
export type Dar_SupplerendeBynavn = {
  __typename?: 'DAR_SupplerendeBynavn';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: Forretningshændelse
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningshændelse
   * prefLabel (da): forretningshændelse
   * definition (da): den forretningshændelse, som afstedkom opdateringen af adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningshaendelse?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forretningsområde
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningsområde
   * prefLabel (da): forretningsområde
   * definition (da): det forretningsområde som har opdateret adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningsomraade?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forretningsproces
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/forretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den forretningsproces, som afstedkom opdateringen af adresseelementet til den pågældende version
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  forretningsproces?: Maybe<Scalars['String']['output']>;
  id_lokalId?: Maybe<Scalars['String']['output']>;
  id_namespace?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/navn
   * prefLabel (da): navn
   * definition (da): navn på den pågældende by, bebyggelse, område e.l.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P11
   */
  navn?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/registreringFra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af den pågældende version af adresseelementet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringFra?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/registreringTil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor en ny registrering på adresseelementet er foretaget, og hvor denne version således ikke længere er den seneste
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/registreringsaktør
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen af den pågældende version af adresseelementet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  registreringsaktoer?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Livscyklus
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/status
   * prefLabel (da): status
   * altLabel (da): status
   * definition (da): adresseelementets status i den pågældende version, dvs. elementets tilstand i den samlede livscyklus
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271#P39|||https://www.retsinformation.dk/eli/lta/2018/271#P45
   */
  status?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: SupplerendeBynavn
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/supplerendeBynavnnavn
   * prefLabel (da): supplerende bynavn
   * definition (da): reference for DAGI's objekt for det supplerende bynavn
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  supplerendeBynavn?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/virkningFra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra den pågældende version af adresseelementet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningFra?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/dar/virkningTil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor virkningen af den pågældende version af adresseelementet ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: Virkningsaktør
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/dar/virkningsaktør
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet virkningsegenskaberne for den pågældende version af adresseelementet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/271
   */
  virkningsaktoer?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Dar_SupplerendeBynavnConnection = {
  __typename?: 'DAR_SupplerendeBynavnConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Dar_SupplerendeBynavnEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Dar_SupplerendeBynavn>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Dar_SupplerendeBynavnEdge = {
  __typename?: 'DAR_SupplerendeBynavnEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Dar_SupplerendeBynavn;
};

export type Dar_SupplerendeBynavnFilterInput = {
  and?: InputMaybe<Array<Dar_SupplerendeBynavnFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  navn?: InputMaybe<DafSearchableStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringsaktoer?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  supplerendeBynavn?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

export type DafBoundedCharOperationFilterInput = {
  eq?: InputMaybe<Scalars['Char']['input']>;
  in?: InputMaybe<Array<Scalars['Char']['input']>>;
};

export type DafBoundedIntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type DafBoundedLongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export type DafBoundedStringOperationFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DafDateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DafDateTime']['input']>;
  gt?: InputMaybe<Scalars['DafDateTime']['input']>;
  gte?: InputMaybe<Scalars['DafDateTime']['input']>;
  lt?: InputMaybe<Scalars['DafDateTime']['input']>;
  lte?: InputMaybe<Scalars['DafDateTime']['input']>;
  ngt?: InputMaybe<Scalars['DafDateTime']['input']>;
  ngte?: InputMaybe<Scalars['DafDateTime']['input']>;
  nlt?: InputMaybe<Scalars['DafDateTime']['input']>;
  nlte?: InputMaybe<Scalars['DafDateTime']['input']>;
};

export type DafIntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type DafSearchableStringOperationFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type DafStringOperationFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DafUuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Query type for DAR - Danmarks Adresseregister */
export type Query = {
  __typename?: 'Query';
  DAF_RegisterImportStatus?: Maybe<Daf_RegisterImportStatus>;
  DAR_Adresse?: Maybe<Dar_AdresseConnection>;
  DAR_Adressepunkt?: Maybe<Dar_AdressepunktConnection>;
  DAR_Events?: Maybe<Dar_EventsConnection>;
  DAR_Husnummer?: Maybe<Dar_HusnummerConnection>;
  DAR_NavngivenVej?: Maybe<Dar_NavngivenVejConnection>;
  DAR_NavngivenVejKommunedel?: Maybe<Dar_NavngivenVejKommunedelConnection>;
  DAR_NavngivenVejPostnummer?: Maybe<Dar_NavngivenVejPostnummerConnection>;
  DAR_NavngivenVejSupplerendeBynavn?: Maybe<Dar_NavngivenVejSupplerendeBynavnConnection>;
  DAR_Postnummer?: Maybe<Dar_PostnummerConnection>;
  DAR_SupplerendeBynavn?: Maybe<Dar_SupplerendeBynavnConnection>;
};

/** Query type for DAR - Danmarks Adresseregister */
export type QueryDar_AdresseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Dar_AdresseFilterInput>;
};

/** Query type for DAR - Danmarks Adresseregister */
export type QueryDar_AdressepunktArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Dar_AdressepunktFilterInput>;
};

/** Query type for DAR - Danmarks Adresseregister */
export type QueryDar_EventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dar_EventsFilterInput>;
};

/** Query type for DAR - Danmarks Adresseregister */
export type QueryDar_HusnummerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Dar_HusnummerFilterInput>;
};

/** Query type for DAR - Danmarks Adresseregister */
export type QueryDar_NavngivenVejArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Dar_NavngivenVejFilterInput>;
};

/** Query type for DAR - Danmarks Adresseregister */
export type QueryDar_NavngivenVejKommunedelArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Dar_NavngivenVejKommunedelFilterInput>;
};

/** Query type for DAR - Danmarks Adresseregister */
export type QueryDar_NavngivenVejPostnummerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Dar_NavngivenVejPostnummerFilterInput>;
};

/** Query type for DAR - Danmarks Adresseregister */
export type QueryDar_NavngivenVejSupplerendeBynavnArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Dar_NavngivenVejSupplerendeBynavnFilterInput>;
};

/** Query type for DAR - Danmarks Adresseregister */
export type QueryDar_PostnummerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Dar_PostnummerFilterInput>;
};

/** Query type for DAR - Danmarks Adresseregister */
export type QueryDar_SupplerendeBynavnArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Dar_SupplerendeBynavnFilterInput>;
};

/** Filter type for the spatial method ST_Contains. Is applied as ST_Contains(A, B) where A is the register data field and B is the input value. */
export type SpatialContainsOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

/** Filter type for the spatial method ST_CoveredBy. Is applied as ST_CoveredBy(A, B) where A is the register data field and B is the input value. */
export type SpatialCoveredByOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

/** Filter type for the spatial method ST_Covers. Is applied as ST_Covers(A, B) where A is the register data field and B is the input value. */
export type SpatialCoversOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

/** Filter type for the spatial method ST_Crosses. Is applied as ST_Crosses(A, B) where A is the register data field and B is the input value. */
export type SpatialCrossesOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

export enum SpatialDimensionEnumType {
  Xy = 'XY',
  Xyz = 'XYZ',
}

export type SpatialFilterInput = {
  and?: InputMaybe<Array<SpatialFilterInput>>;
  contains?: InputMaybe<SpatialContainsOperationFilterInput>;
  coveredBy?: InputMaybe<SpatialCoveredByOperationFilterInput>;
  covers?: InputMaybe<SpatialCoversOperationFilterInput>;
  crosses?: InputMaybe<SpatialCrossesOperationFilterInput>;
  intersects?: InputMaybe<SpatialIntersectsOperationFilterInput>;
  or?: InputMaybe<Array<SpatialFilterInput>>;
  overlaps?: InputMaybe<SpatialOverlapsOperationFilterInput>;
  touches?: InputMaybe<SpatialTouchesOperationFilterInput>;
  within?: InputMaybe<SpatialWithinOperationFilterInput>;
};

export enum SpatialGeometryNameEnumType {
  LineString = 'LineString',
  MultiLineString = 'MultiLineString',
  MultiPoint = 'MultiPoint',
  MultiPolygon = 'MultiPolygon',
  Point = 'Point',
  Polygon = 'Polygon',
}

export type SpatialInterfaceType = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['output'];
  /** The dimensions used by the geometry. */
  dimension: SpatialDimensionEnumType;
  /** The OGC geometry type of the geometry. */
  type: SpatialGeometryNameEnumType;
  /** The WKT representation of the geometry */
  wkt?: Maybe<Scalars['String']['output']>;
};

/** Filter type for the spatial method ST_Intersects. Is applied as ST_Intersects(A, B) where A is the register data field and B is the input value. */
export type SpatialIntersectsOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

/** Spatial MultiLineString type with XY-dimensions in the EPSG 25832 coordinate system. */
export type SpatialMultiLineStringEpsg25832Type = SpatialInterfaceType & {
  __typename?: 'SpatialMultiLineStringEpsg25832Type';
  crs: Scalars['Int']['output'];
  dimension: SpatialDimensionEnumType;
  type: SpatialGeometryNameEnumType;
  wkt: Scalars['String']['output'];
};

/** Spatial MultiPoint type with XY-dimensions in the EPSG 25832 coordinate system. */
export type SpatialMultiPointEpsg25832Type = SpatialInterfaceType & {
  __typename?: 'SpatialMultiPointEpsg25832Type';
  crs: Scalars['Int']['output'];
  dimension: SpatialDimensionEnumType;
  type: SpatialGeometryNameEnumType;
  wkt: Scalars['String']['output'];
};

/** Filter type for the spatial method ST_Overlaps. Is applied as ST_Overlaps(A, B) where A is the register data field and B is the input value. */
export type SpatialOverlapsOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

/** Spatial Point type with XY-dimensions in the EPSG 25832 coordinate system. */
export type SpatialPointEpsg25832Type = SpatialInterfaceType & {
  __typename?: 'SpatialPointEpsg25832Type';
  crs: Scalars['Int']['output'];
  dimension: SpatialDimensionEnumType;
  type: SpatialGeometryNameEnumType;
  wkt: Scalars['String']['output'];
};

/** Spatial Polygon type with XY-dimensions in the EPSG 25832 coordinate system. */
export type SpatialPolygonEpsg25832Type = SpatialInterfaceType & {
  __typename?: 'SpatialPolygonEpsg25832Type';
  crs: Scalars['Int']['output'];
  dimension: SpatialDimensionEnumType;
  type: SpatialGeometryNameEnumType;
  wkt: Scalars['String']['output'];
};

/** Filter type for the spatial method ST_Touches. Is applied as ST_Touches(A, B) where A is the register data field and B is the input value. */
export type SpatialTouchesOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

/** Filter type for the spatial method ST_Within. Is applied as ST_Within(A, B) where A is the register data field and B is the input value. */
export type SpatialWithinOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

/** Subscription type for DAR - Danmarks Adresseregister */
export type Subscription = {
  __typename?: 'Subscription';
  DAF_RegisterImportStatus: Daf_RegisterImportStatus;
  DAR_Events: Dar_Events;
};

/** Subscription type for DAR - Danmarks Adresseregister */
export type SubscriptionDar_EventsArgs = {
  where?: InputMaybe<Dar_EventsFilterInput>;
};

export type DarAdresseByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type DarAdresseByIdQuery = {
  __typename?: 'Query';
  DAR_Adresse?: {
    __typename?: 'DAR_AdresseConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      endCursor?: string | null;
    };
    nodes?: Array<{
      __typename?: 'DAR_Adresse';
      datafordelerRowId: string;
      datafordelerRowVersion: number;
      datafordelerRegisterImportSequenceNumber: number;
      datafordelerOpdateringstid?: string | null;
      id_lokalId?: string | null;
      id_namespace?: string | null;
      adressebetegnelse?: string | null;
      bygning?: string | null;
      husnummer?: string | null;
      etagebetegnelse?: string | null;
      doerbetegnelse?: string | null;
      doerpunkt?: string | null;
      forretningshaendelse?: string | null;
      forretningsomraade?: string | null;
      forretningsproces?: string | null;
      registreringFra?: string | null;
      registreringTil?: string | null;
      registreringsaktoer?: string | null;
      virkningFra?: string | null;
      virkningTil?: string | null;
      virkningsaktoer?: string | null;
      status?: string | null;
    }> | null;
  } | null;
};

export type DarAdresseByTextQueryVariables = Exact<{
  text: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  registreringstid: Scalars['DafDateTime']['input'];
}>;

export type DarAdresseByTextQuery = {
  __typename?: 'Query';
  DAR_Adresse?: {
    __typename?: 'DAR_AdresseConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      endCursor?: string | null;
    };
    nodes?: Array<{
      __typename?: 'DAR_Adresse';
      datafordelerRowId: string;
      datafordelerRowVersion: number;
      datafordelerRegisterImportSequenceNumber: number;
      datafordelerOpdateringstid?: string | null;
      id_lokalId?: string | null;
      id_namespace?: string | null;
      adressebetegnelse?: string | null;
      bygning?: string | null;
      husnummer?: string | null;
      etagebetegnelse?: string | null;
      doerbetegnelse?: string | null;
      doerpunkt?: string | null;
      forretningshaendelse?: string | null;
      forretningsomraade?: string | null;
      forretningsproces?: string | null;
      registreringFra?: string | null;
      registreringTil?: string | null;
      registreringsaktoer?: string | null;
      virkningFra?: string | null;
      virkningTil?: string | null;
      virkningsaktoer?: string | null;
      status?: string | null;
    }> | null;
  } | null;
};

export type DarHusnummerByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid: Scalars['DafDateTime']['input'];
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
}>;

export type DarHusnummerByIdQuery = {
  __typename?: 'Query';
  DAR_Husnummer?: {
    __typename?: 'DAR_HusnummerConnection';
    nodes?: Array<{
      __typename?: 'DAR_Husnummer';
      id_lokalId?: string | null;
      husnummertekst?: string | null;
      postnummer?: string | null;
      kommuneinddeling?: string | null;
      jordstykke?: string | null;
      placeretPaaForeloebigtJordstykke?: string | null;
      adgangspunkt?: string | null;
      vejmidte?: string | null;
    }> | null;
  } | null;
};

export type DarAdressepunktByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid: Scalars['DafDateTime']['input'];
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
}>;

export type DarAdressepunktByIdQuery = {
  __typename?: 'Query';
  DAR_Adressepunkt?: {
    __typename?: 'DAR_AdressepunktConnection';
    nodes?: Array<{
      __typename?: 'DAR_Adressepunkt';
      id_lokalId?: string | null;
      position?: {
        __typename?: 'SpatialPointEpsg25832Type';
        wkt: string;
        crs: number;
      } | null;
    }> | null;
  } | null;
};

export type DarPostnummerByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid: Scalars['DafDateTime']['input'];
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
}>;

export type DarPostnummerByIdQuery = {
  __typename?: 'Query';
  DAR_Postnummer?: {
    __typename?: 'DAR_PostnummerConnection';
    nodes?: Array<{
      __typename?: 'DAR_Postnummer';
      id_lokalId?: string | null;
      postnr?: string | null;
      navn?: string | null;
    }> | null;
  } | null;
};

export type DarRegisterImportStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type DarRegisterImportStatusQuery = {
  __typename?: 'Query';
  DAF_RegisterImportStatus?: {
    __typename?: 'DAF_RegisterImportStatus';
    lastEventId: number;
    lastSequenceNumber: number;
    lastUpdated: string;
  } | null;
};

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<
    DocumentTypeDecoration<TResult, TVariables>['__apiType']
  >;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const DarAdresseByIdDocument = new TypedDocumentString(`
    query DarAdresseById($id: String!, $first: Int = 10, $after: String) {
  DAR_Adresse(first: $first, after: $after, where: {id_lokalId: {eq: $id}}) {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      datafordelerRowId
      datafordelerRowVersion
      datafordelerRegisterImportSequenceNumber
      datafordelerOpdateringstid
      id_lokalId
      id_namespace
      adressebetegnelse
      bygning
      husnummer
      etagebetegnelse
      doerbetegnelse
      doerpunkt
      forretningshaendelse
      forretningsomraade
      forretningsproces
      registreringFra
      registreringTil
      registreringsaktoer
      virkningFra
      virkningTil
      virkningsaktoer
      status
    }
  }
}
    `);
export const DarAdresseByTextDocument = new TypedDocumentString(`
    query DarAdresseByText($text: String!, $first: Int = 10, $after: String, $registreringstid: DafDateTime!) {
  DAR_Adresse(
    first: $first
    after: $after
    registreringstid: $registreringstid
    where: {adressebetegnelse: {startsWith: $text}}
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      datafordelerRowId
      datafordelerRowVersion
      datafordelerRegisterImportSequenceNumber
      datafordelerOpdateringstid
      id_lokalId
      id_namespace
      adressebetegnelse
      bygning
      husnummer
      etagebetegnelse
      doerbetegnelse
      doerpunkt
      forretningshaendelse
      forretningsomraade
      forretningsproces
      registreringFra
      registreringTil
      registreringsaktoer
      virkningFra
      virkningTil
      virkningsaktoer
      status
    }
  }
}
    `);
export const DarHusnummerByIdDocument = new TypedDocumentString(`
    query DarHusnummerById($id: String!, $first: Int = 1, $registreringstid: DafDateTime!, $virkningstid: DafDateTime) {
  DAR_Husnummer(
    first: $first
    registreringstid: $registreringstid
    virkningstid: $virkningstid
    where: {id_lokalId: {eq: $id}}
  ) {
    nodes {
      id_lokalId
      husnummertekst
      postnummer
      kommuneinddeling
      jordstykke
      placeretPaaForeloebigtJordstykke
      adgangspunkt
      vejmidte
    }
  }
}
    `);
export const DarAdressepunktByIdDocument = new TypedDocumentString(`
    query DarAdressepunktById($id: String!, $first: Int = 1, $registreringstid: DafDateTime!, $virkningstid: DafDateTime) {
  DAR_Adressepunkt(
    first: $first
    registreringstid: $registreringstid
    virkningstid: $virkningstid
    where: {id_lokalId: {eq: $id}}
  ) {
    nodes {
      id_lokalId
      position {
        wkt
        crs
      }
    }
  }
}
    `);
export const DarPostnummerByIdDocument = new TypedDocumentString(`
    query DarPostnummerById($id: String!, $first: Int = 1, $registreringstid: DafDateTime!, $virkningstid: DafDateTime) {
  DAR_Postnummer(
    first: $first
    registreringstid: $registreringstid
    virkningstid: $virkningstid
    where: {id_lokalId: {eq: $id}}
  ) {
    nodes {
      id_lokalId
      postnr
      navn
    }
  }
}
    `);
export const DarRegisterImportStatusDocument = new TypedDocumentString(`
    query DarRegisterImportStatus {
  DAF_RegisterImportStatus {
    lastEventId
    lastSequenceNumber
    lastUpdated
  }
}
    `);

const injectedRtkApi = darGraphqlApiSlice.injectEndpoints({
  endpoints: (build) => ({
    DarAdresseById: build.query<
      DarAdresseByIdQuery,
      DarAdresseByIdQueryVariables
    >({
      query: (variables) => ({
        document: DarAdresseByIdDocument.toString(),
        variables,
      }),
      transformResponse: (response: DarAdresseByIdQuery) => response,
    }),
    DarAdresseByText: build.query<
      DarAdresseByTextQuery,
      DarAdresseByTextQueryVariables
    >({
      query: (variables) => ({
        document: DarAdresseByTextDocument.toString(),
        variables,
      }),
      transformResponse: (response: DarAdresseByTextQuery) => response,
    }),
    DarHusnummerById: build.query<
      DarHusnummerByIdQuery,
      DarHusnummerByIdQueryVariables
    >({
      query: (variables) => ({
        document: DarHusnummerByIdDocument.toString(),
        variables,
      }),
      transformResponse: (response: DarHusnummerByIdQuery) => response,
    }),
    DarAdressepunktById: build.query<
      DarAdressepunktByIdQuery,
      DarAdressepunktByIdQueryVariables
    >({
      query: (variables) => ({
        document: DarAdressepunktByIdDocument.toString(),
        variables,
      }),
      transformResponse: (response: DarAdressepunktByIdQuery) => response,
    }),
    DarPostnummerById: build.query<
      DarPostnummerByIdQuery,
      DarPostnummerByIdQueryVariables
    >({
      query: (variables) => ({
        document: DarPostnummerByIdDocument.toString(),
        variables,
      }),
      transformResponse: (response: DarPostnummerByIdQuery) => response,
    }),
    DarRegisterImportStatus: build.query<
      DarRegisterImportStatusQuery,
      DarRegisterImportStatusQueryVariables | void
    >({
      query: (variables) => ({
        document: DarRegisterImportStatusDocument.toString(),
        variables,
      }),
      transformResponse: (response: DarRegisterImportStatusQuery) => response,
    }),
  }),
});

export { injectedRtkApi as api };
export const {
  useDarAdresseByIdQuery,
  useLazyDarAdresseByIdQuery,
  useDarAdresseByTextQuery,
  useLazyDarAdresseByTextQuery,
  useDarHusnummerByIdQuery,
  useLazyDarHusnummerByIdQuery,
  useDarAdressepunktByIdQuery,
  useLazyDarAdressepunktByIdQuery,
  useDarPostnummerByIdQuery,
  useLazyDarPostnummerByIdQuery,
  useDarRegisterImportStatusQuery,
  useLazyDarRegisterImportStatusQuery,
} = injectedRtkApi;
